module.exports = {
    'Header': require('./header'),
    'Footer': require('./footer'),
    'ModuleSpacing': require('./module-spacing')
};